import tagsGroupConstants from '@shared/constants/overview/TagsGroupConstants';

export const OBJECTS_TYPE = {
    GGL_CAMPAIGN: 'google_campaigns',
    FB_AD_SET: 'facebook_ad_sets',
    FB_CAMPAIGN: 'facebook_campaigns',
    IN_CAMPAIGN: 'ineligible_campaigns',
};

export const OBJECTS_LABEL_BY_TYPE = {
    google_campaigns: 'Google Ads',
    facebook_ad_sets: 'Facebook Ads',
    facebook_campaigns: 'Facebook Ads',
    ineligible_campaigns: '',
};

export const PLATFORM = {
    GGL: tagsGroupConstants.GOOGLE_ADS,
    FB: tagsGroupConstants.FACEBOOK_ADS,
};

export const BUDGET_MANAGER = 'Budget Manager Automation';

export const ACCORDION_TOOLTIP_TEXT = {
    [OBJECTS_TYPE.FB_CAMPAIGN]: 'CBO means Campaign Budget Optimization, that is, only campaigns that have campaign level budget. This type of configuration allows Facebook to decide which adsets within the same campaign will receive more investment than others. It\'s not possible to tag an adset of a CBO campaign, only the campaign itself.',
    [OBJECTS_TYPE.FB_AD_SET]: 'Only adsets of campaigns that have adset level budget. It’s possible to tag adsets from the same non-CBO campaign differently, according to each adset goal or strategy. It\'s not possible to tag campaigns with adset level budget, only adsets.',
    [OBJECTS_TYPE.IN_CAMPAIGN]: 'Campaigns that can\'t be clustered and optimized by Omnichannel Budget Manager. You can see the reason why each of them is ineligible below.',
};

export const LIFETIME_BUDGET = 'lifetime_budget';

export const INNELIGIBLE_REASON_TEXT = {
    'Google Express': "Google Express campaigns can't be optimized by OBM.",
    Experiment: 'Google experiment campaigns are automatically grouped into the same cluster as the original campaign it is being tested against.',
    'Lifetime Budget': 'This campaign is using lifetime budget. The OBM is only able to optimizes campaigns with daily budgets.',
    'Shared Budget': 'Campaigns that share budget with other ones cannot be optimized. Please, remove the shared budget and choose a daily budget so this campaign can be optimized.',
};

export const OBJECT_STATS_STATUS = {
    enabled: 'enabled',
    paused: 'paused',
};
